import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { Stack, styled, Text } from '@ltvco/refresh-lib/theme';
import { HistoryRounded } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { constants } from 'appConstants';

import DigitalMonitoringBanner from './DigitalMonitoringBanner';
import { IdentityMonitorTab } from './IdentityMonitorTab';
import PersonalityTraitsBanner from './PersonalityTraitsBanner';
import { RewardsOffersTab } from './RewardsOffersTab';

export const TopSection = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(1.5),
}));

export const TopSubtitle = styled(Text)(({ theme }) => ({
  textAlign: 'center',
  width: '75%',
  marginBottom: '24px',
  [theme.breakpoints.down('sm')]: {
    width: '80%',
  },
}));

export const MemberPerksTabs = () => {
  const [, setActiveTab] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const { isHidden } = useSubscriptionAccessConfigContext();
  const rewardsLogo = constants.images.imgRewardsLogo;

  const footPrintReportTypes = [
    'person',
    'phone',
    'vehicle',
    'email',
    'property',
  ];

  const hideDashboardDigitalFootprint = footPrintReportTypes.some((type) =>
    isHidden(type)
  );

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    const permalink = searchParams.get('permalink');

    if (tabParam === 'rewards' || permalink) {
      setActiveTab(1);
      setTimeout(() => setSearchParams({}, { replace: true }), 500);
    }
  }, [searchParams]);

  return (
    <Stack direction="column" padding={{ xs: 2.5, sm: 0 }}>
      <Stack spacing={2} my={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <HistoryRounded sx={{ fontSize: '1.25rem' }} />
          <Text variant="h3">Member's Perks</Text>
        </Stack>

        <TopSection>
          <img src={rewardsLogo} alt="rewards" width={'100px'} />

          <Text variant="h2" marginBottom="16px">
            Rewards and Offers
          </Text>

          <TopSubtitle>
            As a BeenVerified member, you have access to exclusive benefits
            included with your subscription. We’re continuously adding new
            offers, so check back regularly to stay up to date.
          </TopSubtitle>
        </TopSection>
      </Stack>
      {!hideDashboardDigitalFootprint && <DigitalMonitoringBanner />}
      <PersonalityTraitsBanner />
      <RewardsOffersTab />
      <IdentityMonitorTab />
    </Stack>
  );
};
